import { render, staticRenderFns } from "./liveevents-config.vue?vue&type=template&id=1ac0bbb3&"
import script from "./liveevents-config.vue?vue&type=script&lang=ts&"
export * from "./liveevents-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports